import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../RootState";

import {
  TicketDepartmentType,
  TicketInfoType,
  TicketMessageType,
  TicketPriorityType,
  TicketStatusType,
} from "../../Types/Ticket.model";

type InitialStateType = {
  ticketInfo: TicketInfoType | undefined;
  ticketLoading: boolean | undefined;
  ticketPageNumber: number;
  ticketTotalPages: number;
  ticketStatus: TicketStatusType | undefined;
  ticketDepartment: TicketDepartmentType | undefined;
  ticketPriority: TicketPriorityType | undefined;
  sentMessage: TicketMessageType | undefined;
  editingMessage: TicketMessageType | undefined;
  isMessageError: boolean;
};

const initialState: InitialStateType = {
  ticketInfo: undefined,
  ticketLoading: false,
  ticketPageNumber: 1,
  ticketTotalPages: 1,
  ticketStatus: undefined,
  ticketDepartment: undefined,
  ticketPriority: undefined,
  sentMessage: undefined,
  editingMessage: undefined,
  isMessageError: false,
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    setTicketInfo: (state, action) => {
      state.ticketInfo = action.payload;
    },
    setTicketLoading: (state, action) => {
      state.ticketLoading = action.payload;
    },
    setTicketPageNumber: (state, action) => {
      state.ticketPageNumber = action.payload;
    },
    setTicketTotalPages: (state, action) => {
      state.ticketTotalPages = action.payload;
    },
    setTicketStatus: (state, action) => {
      state.ticketStatus = action.payload;
    },
    setTicketDepartment: (state, action) => {
      state.ticketDepartment = action.payload;
    },
    setTicketPriority: (state, action) => {
      state.ticketPriority = action.payload;
    },
    setSentMessage: (state, action) => {
      state.sentMessage = action.payload;
    },
    setEditingMessage: (state, action) => {
      state.editingMessage = action.payload;
    },
    setIsMessageError: (state, action) => {
      state.isMessageError = action.payload;
    },
  },
});

export const { setTicketInfo } = ticketSlice.actions;
export const { setTicketLoading } = ticketSlice.actions;
export const { setTicketPageNumber } = ticketSlice.actions;
export const { setTicketTotalPages } = ticketSlice.actions;
export const { setTicketStatus } = ticketSlice.actions;
export const { setTicketDepartment } = ticketSlice.actions;
export const { setTicketPriority } = ticketSlice.actions;
export const { setSentMessage } = ticketSlice.actions;
export const { setEditingMessage } = ticketSlice.actions;
export const { setIsMessageError } = ticketSlice.actions;

export const ticketInfoSelector = (state: RootState) => state.ticket.ticketInfo;
export const ticketLoadingSelector = (state: RootState) =>
  state.ticket.ticketLoading;
export const ticketPageNumberSelector = (state: RootState) =>
  state.ticket.ticketPageNumber;
export const ticketTotalPagesSelector = (state: RootState) =>
  state.ticket.ticketTotalPages;
export const ticketStatusSelector = (state: RootState) =>
  state.ticket.ticketStatus;
export const ticketDepartmentSelector = (state: RootState) =>
  state.ticket.ticketDepartment;
export const ticketPrioritySelector = (state: RootState) =>
  state.ticket.ticketPriority;
export const sentMessageSelector = (state: RootState) =>
  state.ticket.sentMessage;
export const editingMessageSelector = (state: RootState) =>
  state.ticket.editingMessage;
export const isMessageErrorSelector = (state: RootState) =>
  state.ticket.isMessageError;

export default ticketSlice.reducer;
